module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "UserInfo"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', [_c('div', {
    staticClass: "md-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.givenName),
      expression: "givenName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "id": "csp_fname",
      "name": "fname",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.givenName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.givenName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.givenName
    },
    attrs: {
      "for": "csp_fname"
    }
  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "md-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surName),
      expression: "surName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "text",
      "id": "csp_lname",
      "name": "lname",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.surName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.surName
    },
    attrs: {
      "for": "csp_lname"
    }
  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('div', {
    staticClass: "md-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "email",
      "id": "csp_email",
      "name": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.emailAddress
    },
    attrs: {
      "for": "csp_email"
    }
  }, [_vm._v("Email Address")])]), _vm._v(" "), _c('div', {
    staticClass: "md-form"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ({
        mask: _vm.phoneNumberMask,
        jitMasking: true,
        placeholder: ' ',
        returnUnmasked: true
      }),
      expression: "{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "tel",
      "id": "csp_tel_home",
      "name": "tel",
      "autocomplete": "tel"
    },
    domProps: {
      "value": _vm.homePhoneNumber
    },
    on: {
      "maskinput": _vm.updateHomePhoneNumber
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.homePhoneNumber
    },
    attrs: {
      "for": "csp_tel_home"
    }
  }, [_vm._v("Phone Number (Home)")])]), _vm._v(" "), _c('div', {
    staticClass: "md-form"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ({
        mask: _vm.phoneNumberMask,
        jitMasking: true,
        placeholder: ' ',
        returnUnmasked: true
      }),
      expression: "{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "csp_tel_mobile",
      "name": "tel",
      "autocomplete": "tel"
    },
    domProps: {
      "value": _vm.mobilePhoneNumber
    },
    on: {
      "maskinput": _vm.updateMobilePhoneNumber
    }
  }), _vm._v(" "), _c('label', {
    class: {
      active: _vm.mobilePhoneNumber
    },
    attrs: {
      "for": "csp_tel_mobile"
    }
  }, [_vm._v("Phone Number (Mobile)")])]), _vm._v(" "), _c('div', {
    staticClass: "md-form"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-xs-12 card-title csp-card-title"
  }, [_vm._v("Contact Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 "
  }, [_c('p', {
    staticClass: "card-text csp-banner-text"
  }, [_vm._v("Go ahead and make any change you need!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-982b3c40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/panels/UserInfo.vue
// module id = 860
// module chunks = 2